<template>
    <div class="page-header">
      <h2>Order {{ $route.params.id }} summary</h2>
    </div>

    <template v-if="Object.keys(order_data).length !== 0">
      <table style="border: none !important;table-layout: auto; text-align: center;" v-if="order_data.curr_status.status_id!=-2">
        <tr style="border: none !important;">
          <th>
            <h4>Order Status: </h4>
          </th>
        </tr>
        <tr style="border: none !important;">
          <th style="border: none !important;" v-for="status in purchase_status_ordered" :key="status"> 
            <template v-if="status.status_id==order_data.curr_status.status_id">
              <div class="w3-card w3-center w3-hover-shadow w3-round w3-margin w3-pale-blue">
                <div class="w3-container">
                  <h5>{{status.name}}.</h5>
                  <!-- <h6><b>{{status.description}}</b></h6> -->
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="status.status_id >= current_status_index_in_purchase_status_ordered && status.status_id != 0">
                <div class="w3-card w3-center w3-hover-shadow w3-round w3-margin w3-white">
                  <div class="w3-container">
                    <h5>{{status.name}}.</h5>
                    <!-- <h6>{{status.description}}</h6> -->
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="w3-card w3-center w3-hover-shadow w3-round w3-margin w3-light-gray">
                  <div class="w3-container">
                    <h5>{{status.name}}.</h5>
                    <!-- <h6>{{status.description}}</h6> -->
                  </div>
                </div>
              </template>
            </template>
          </th>
        </tr>
      </table>
      <span v-else style="color:red;"> <b> Order CANCELLED </b> </span>
      <br>

      <br>

      <table class="w3-table-all">
        <tr>
          <!-- <th></th> -->
          <th>Product</th>
          <th>Details</th>
          <th>Price/unit</th>
          <th>Quantity</th>
          <th>Price</th>
        </tr>
        <tr v-for="part in order_data.parts" v-bind:key="part">
          <!-- <td>
                      <button>Edit</button>
                  </td> -->
          <td>{{ part.part_name }}</td>
          <td>
            <template v-for="(value, input) in part.userinputs" :key="input">
              <li v-if="value !== ''">{{ input }} : {{ value }}</li>
            </template>
          </td>
          <td>{{calculatePartUnitPrice(part)}} CHF</td>
          <td>{{ part.ori_quantity }}</td>
          <td>{{calculatePartPrice(part)}} CHF</td>
          <!-- <td>{{ item.price }}</td> TODO Calculate price (from basket) -->
        </tr>
      </table>

      <div class="page-header">
        <h3>Order details</h3>
      </div>

      <!-- {{orderDetails.order_userinputs}} -->
      <ul>
        <li><b>Ordered by</b> : {{order_data.ordered_by_details["name"]}}.  <b>Email:</b> {{order_data.ordered_by_details["email"]}} </li>
      </ul>

      <ul v-for="(value, name) in order_data.details" v-bind:key="(name)">
        <li><b>{{name}}</b> : {{value}} </li>
      </ul>

      <template v-if="'shipment' in order_data">
        <div id="shipment_details">
          <div class="page-header">
            <h3>Shipment details</h3>
          </div>

          <ul v-for="(value, name) in order_data.shipment" v-bind:key="(name)">
            <li><b>{{name}}</b> : {{value}} </li>
          </ul>
        </div>
      </template>

    <br />
    <button @click="cancelOrder" :disabled="order_data.curr_status.status_id!=-1" title="An order can only be cancelled on the 'Wait for Acknowledgement' status.">Cancel order</button>
    <div id="order_failed" class="w3-panel w3-red" style="display: none">
      <h3>Failed to send order</h3>
      <p style="white-space: pre-line">{{ order_error }}</p>
    </div>
    <div id="order_success" class="w3-panel w3-green" style="display: none">
      <h3>Success</h3>
      <p>Your order has been cancelled correctly.</p>
    </div>
  </template>
  <template v-else>
    Recovering data...
  </template>
</template>

<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>

<script>
// import { request } from 'express';
export default {
    name: 'OrderDetails',
    props: 
    {
        display: Boolean,
    },
    computed: {
        currentBasket() {
            return this.$store.getters.getBasket;
        },
        allParts() {
            return this.$store.getters.getParts;
        },
        allPackages() {
            return this.$store.getters.getPackages;
        },
        totalPrice() {
            var price = 0;
            this.order_data.parts.forEach(item => {
                price += item.price;
            });
            return price;
        },
        orderDetails() {
            return this.$store.getters.getOrderConfig;
        },
        userDetails() {
            return this.$store.getters.getUserDetails;
        },
        reqshipment() {
            var part_index;
            var reqshipment = false;
            for(part_index = 0; part_index < this.currentBasket.length; part_index++) {
                var part = this.currentBasket[part_index];
                reqshipment = reqshipment | part.reqshipment;
            }      
            return reqshipment;
        },
        purchase_status_ordered() {
          var index;
          var purchase_status_ordered = [];
          for(index = 0 ; index < Object.keys(this.orderDetails.purchase_status).length-1; index++ )
          {
            var key = (index-1).toString()
            purchase_status_ordered.push(this.orderDetails.purchase_status[key])
          }
          purchase_status_ordered.push(purchase_status_ordered[1])
          purchase_status_ordered.splice(1,1)
          console.log(purchase_status_ordered)
          return purchase_status_ordered;
        },
        current_status_index_in_purchase_status_ordered() {
          var index;
          for(index = 0 ; index < this.purchase_status_ordered.length; index++ )
          {
            if (this.purchase_status_ordered[index].status_id == this.order_data.curr_status.status_id )
            {
              return index;
            }
          }

          return 0;
        }
    },
    data() {
        return {
            order_error : "",
            order_data : {}
        }
    },
    methods: {
        calculatePartUnitPrice: function(part) {
          var price_index;
          var unit_price = part.part_unit_prices[0].chf;
          if (part.part_unit_prices.length > 1)
          {
            for (price_index = 0; price_index <= part.part_unit_prices.length-1; price_index++) 
            {
              if (part.act_quantity >= part.part_unit_prices[price_index].qty && part.act_quantity < part.part_unit_prices[price_index+1].qty )
                  unit_price = part.part_unit_prices[price_index].chf;
              else if( part.act_quantity >= part.part_unit_prices[price_index+1].qty)
                  unit_price = part.part_unit_prices[price_index+1].chf;
            }
          }
          return unit_price
        },
        calculatePartPrice: function(part) {
          return this.calculatePartUnitPrice(part) * part.act_quantity;
        }
    },
    // mounted() {
    //     if (this.reqshipment)
    //         document.getElementById('shipment_details').style.display = 'block';
    //     else
    //         document.getElementById('shipment_details').style.display = 'none';      
    // }
    created() {
      // var userOrders = {};
        fetch(process.env.VUE_APP_URL + "/restapi/myorders", {
            method: "GET", 
            headers: {'Accept': 'application/json'}}).then(
                (res) => {
                    res.json().then(
                        (userOrders) => {                
                            console.log(userOrders.orders.some( order => order.id == this.$route.params.id ))
                            if( !userOrders.orders.some( order => order.id == this.$route.params.id ) ) { window.location.replace('/distribution/myorders') }
                            this.order_data = userOrders.orders.filter( order => order.id == this.$route.params.id )[0]
                            console.log(this.order_data)
                        }
                    )
                }
            );
        // var userOrders = {
        //     "status": 0,
        //     "orders": [
        //         {
        //         "id": 26,
        //         "order_date": "2021-09-01 15:37:13.763114",
        //         "shipment": {
        //             "Durée": "1",
        //             "Address": "324"
        //         },
        //         "tobeshipped": true,
        //         "curr_status": {
        //             "id": "",
        //             "call": "",
        //             "file": "",
        //             "name": "Wait for acknowledgement",
        //             "check": false,
        //             "preset": "",
        //             "display": "",
        //             "status_id": -1,
        //             "description": "Initialization - wait for administrator acknowledgement"
        //         },
        //         "next_status": {
        //             "id": "distributions_status.Acknowledged.Acknowledged",
        //             "call": "Acknowledging a request means that all parts have been associated to batches and are\nready to be shipped.\n\nTherefore, before aprouving the \"Acknowledged\" status, the call function checks that\nall of the parts are linked to a production.",
        //             "file": "Acknowledged.py",
        //             "name": "Acknowledged",
        //             "check": true,
        //             "author": "unknown",
        //             "preset": "An option allows skiping the checking.       ",
        //             "display": "The display function shows the purchase status for each part.\nIt will allow to know whether all of the parts are ready or not.",
        //             "version": "unknown",
        //             "location": "distributions_status",
        //             "classname": "Acknowledged",
        //             "status_id": 1,
        //             "description": "# Acknowledged status\n\nThe acknowledged status checks whether all of the devices have been associated to batch or not!\nOnce they have been successfully associated, the status can be changed to the Acknowledged one.\nIf one of the device is not ready, the update will fail."
        //         },
        //         "details": {
        //             "Budget code": "12345"
        //         },
        //         "discount": 0,
        //         "ordered_by_email": "irene.mateos.dominguez@cern.ch",
        //         "ordered_by_id": 3,
        //         "ordered_by_details": {
        //             "sub": "imateosd",
        //             "name": "Irene Mateos Dominguez",
        //             "email": "irene.mateos.dominguez@cern.ch",
        //             "cern_gid": 1399,
        //             "cern_uid": 126591,
        //             "cern_upn": "imateosd",
        //             "username": "imateosd",
        //             "given_name": "Irene",
        //             "family_name": "Mateos Dominguez",
        //             "cern_mail_upn": "imateosd@cern.ch",
        //             "cern_person_id": 839904,
        //             "home_institute": "CERN",
        //             "preferred_username": "imateosd",
        //             "cern_preferred_language": "EN"
        //         },
        //         "parts": [
        //             {
        //             "partpreq_id": 29,
        //             "id": 1,
        //             "ori_quantity": 1,
        //             "qty_assigned": 0,
        //             "userinputs": {
        //                 "Test": "123",
        //                 "TestBoolean": true
        //             },
        //             "part_name": "Virtual part (test - 0)",
        //             "part_description": "This is the first part I create as a test. It is used to check the functionality of the system. Then, I updated it to check wether it is still good or not .. and it looks good! 😁\n\nNext step: add categories!",
        //             "part_available": true,
        //             "part_details": [
        //                 {
        //                 "name": "Max. input voltage",
        //                 "value": "12",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "Min. input voltage",
        //                 "value": "5",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "Max. output voltage",
        //                 "value": "14",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "Min. output voltage",
        //                 "value": "14",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "EDH Proc. code",
        //                 "value": "0",
        //                 "visible": false
        //                 }
        //             ],
        //             "part_unit_prices": [
        //                 {
        //                 "chf": 5,
        //                 "qty": 10
        //                 },
        //                 {
        //                 "chf": 4,
        //                 "qty": 100
        //                 }
        //             ],
        //             "part_user_inputs": [
        //                 {
        //                 "desc": "Test field",
        //                 "name": "Test",
        //                 "type": "text",
        //                 "default": "",
        //                 "options": []
        //                 },
        //                 {
        //                 "desc": "Test boolean input",
        //                 "name": "TestBoolean",
        //                 "type": "boolean",
        //                 "default": "",
        //                 "options": []
        //                 }
        //             ],
        //             "part_batch_req_details": {
        //                 "Build number": "Build reference",
        //                 "Manufacturer": "Company who built the device"
        //             },
        //             "part_purchase_status": []
        //             }
        //         ]
        //         },
        //         {
        //         "id": 27,
        //         "order_date": "2021-09-01 15:48:35.923269",
        //         "shipment": {},
        //         "tobeshipped": false,
        //         "curr_status": {
        //             "id": "",
        //             "call": "",
        //             "file": "",
        //             "name": "Wait for acknowledgement",
        //             "check": false,
        //             "preset": "",
        //             "display": "",
        //             "status_id": -1,
        //             "description": "Initialization - wait for administrator acknowledgement"
        //         },
        //         "next_status": {
        //             "id": "distributions_status.Acknowledged.Acknowledged",
        //             "call": "Acknowledging a request means that all parts have been associated to batches and are\nready to be shipped.\n\nTherefore, before aprouving the \"Acknowledged\" status, the call function checks that\nall of the parts are linked to a production.",
        //             "file": "Acknowledged.py",
        //             "name": "Acknowledged",
        //             "check": true,
        //             "author": "unknown",
        //             "preset": "An option allows skiping the checking.       ",
        //             "display": "The display function shows the purchase status for each part.\nIt will allow to know whether all of the parts are ready or not.",
        //             "version": "unknown",
        //             "location": "distributions_status",
        //             "classname": "Acknowledged",
        //             "status_id": 1,
        //             "description": "# Acknowledged status\n\nThe acknowledged status checks whether all of the devices have been associated to batch or not!\nOnce they have been successfully associated, the status can be changed to the Acknowledged one.\nIf one of the device is not ready, the update will fail."
        //         },
        //         "details": {
        //             "Budget code": "12345"
        //         },
        //         "discount": 0,
        //         "ordered_by_email": "irene.mateos.dominguez@cern.ch",
        //         "ordered_by_id": 3,
        //         "ordered_by_details": {
        //             "sub": "imateosd",
        //             "name": "Irene Mateos Dominguez",
        //             "email": "irene.mateos.dominguez@cern.ch",
        //             "cern_gid": 1399,
        //             "cern_uid": 126591,
        //             "cern_upn": "imateosd",
        //             "username": "imateosd",
        //             "given_name": "Irene",
        //             "family_name": "Mateos Dominguez",
        //             "cern_mail_upn": "imateosd@cern.ch",
        //             "cern_person_id": 839904,
        //             "home_institute": "CERN",
        //             "preferred_username": "imateosd",
        //             "cern_preferred_language": "EN"
        //         },
        //         "parts": [
        //             {
        //             "partpreq_id": 30,
        //             "id": 4,
        //             "ori_quantity": 11,
        //             "qty_assigned": 0,
        //             "userinputs": {},
        //             "part_name": "Chikita",
        //             "part_description": "Banana bending ASIC",
        //             "part_available": true,
        //             "part_details": [
        //                 {
        //                 "name": "test key 0",
        //                 "value": "0",
        //                 "visible": true
        //                 }
        //             ],
        //             "part_unit_prices": [
        //                 {
        //                 "chf": 350,
        //                 "qty": 1
        //                 },
        //                 {
        //                 "chf": 300,
        //                 "qty": 10
        //                 }
        //             ],
        //             "part_user_inputs": [],
        //             "part_batch_req_details": {},
        //             "part_purchase_status": []
        //             }
        //         ]
        //         },
        //         {
        //         "id": 28,
        //         "order_date": "2021-09-01 15:49:23.732852",
        //         "shipment": {
        //             "Durée": "1",
        //             "Address": "324"
        //         },
        //         "tobeshipped": true,
        //         "curr_status": {
        //             "id": "",
        //             "call": "",
        //             "file": "",
        //             "name": "Wait for acknowledgement",
        //             "check": false,
        //             "preset": "",
        //             "display": "",
        //             "status_id": -1,
        //             "description": "Initialization - wait for administrator acknowledgement"
        //         },
        //         "next_status": {
        //             "id": "distributions_status.Acknowledged.Acknowledged",
        //             "call": "Acknowledging a request means that all parts have been associated to batches and are\nready to be shipped.\n\nTherefore, before aprouving the \"Acknowledged\" status, the call function checks that\nall of the parts are linked to a production.",
        //             "file": "Acknowledged.py",
        //             "name": "Acknowledged",
        //             "check": true,
        //             "author": "unknown",
        //             "preset": "An option allows skiping the checking.       ",
        //             "display": "The display function shows the purchase status for each part.\nIt will allow to know whether all of the parts are ready or not.",
        //             "version": "unknown",
        //             "location": "distributions_status",
        //             "classname": "Acknowledged",
        //             "status_id": 1,
        //             "description": "# Acknowledged status\n\nThe acknowledged status checks whether all of the devices have been associated to batch or not!\nOnce they have been successfully associated, the status can be changed to the Acknowledged one.\nIf one of the device is not ready, the update will fail."
        //         },
        //         "details": {
        //             "Budget code": "12345"
        //         },
        //         "discount": 0,
        //         "ordered_by_email": "irene.mateos.dominguez@cern.ch",
        //         "ordered_by_id": 3,
        //         "ordered_by_details": {
        //             "sub": "imateosd",
        //             "name": "Irene Mateos Dominguez",
        //             "email": "irene.mateos.dominguez@cern.ch",
        //             "cern_gid": 1399,
        //             "cern_uid": 126591,
        //             "cern_upn": "imateosd",
        //             "username": "imateosd",
        //             "given_name": "Irene",
        //             "family_name": "Mateos Dominguez",
        //             "cern_mail_upn": "imateosd@cern.ch",
        //             "cern_person_id": 839904,
        //             "home_institute": "CERN",
        //             "preferred_username": "imateosd",
        //             "cern_preferred_language": "EN"
        //         },
        //         "parts": [
        //             {
        //             "partpreq_id": 31,
        //             "id": 1,
        //             "ori_quantity": 12,
        //             "qty_assigned": 0,
        //             "userinputs": {
        //                 "Test": "213",
        //                 "TestBoolean": true
        //             },
        //             "part_name": "Virtual part (test - 0)",
        //             "part_description": "This is the first part I create as a test. It is used to check the functionality of the system. Then, I updated it to check wether it is still good or not .. and it looks good! 😁\n\nNext step: add categories!",
        //             "part_available": true,
        //             "part_details": [
        //                 {
        //                 "name": "Max. input voltage",
        //                 "value": "12",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "Min. input voltage",
        //                 "value": "5",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "Max. output voltage",
        //                 "value": "14",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "Min. output voltage",
        //                 "value": "14",
        //                 "visible": true
        //                 },
        //                 {
        //                 "name": "EDH Proc. code",
        //                 "value": "0",
        //                 "visible": false
        //                 }
        //             ],
        //             "part_unit_prices": [
        //                 {
        //                 "chf": 5,
        //                 "qty": 10
        //                 },
        //                 {
        //                 "chf": 4,
        //                 "qty": 100
        //                 }
        //             ],
        //             "part_user_inputs": [
        //                 {
        //                 "desc": "Test field",
        //                 "name": "Test",
        //                 "type": "text",
        //                 "default": "",
        //                 "options": []
        //                 },
        //                 {
        //                 "desc": "Test boolean input",
        //                 "name": "TestBoolean",
        //                 "type": "boolean",
        //                 "default": "",
        //                 "options": []
        //                 }
        //             ],
        //             "part_batch_req_details": {
        //                 "Build number": "Build reference",
        //                 "Manufacturer": "Company who built the device"
        //             },
        //             "part_purchase_status": []
        //             }
        //         ]
        //         }
        //         ]
        //     }
        // console.log(userOrders.orders.some( order => order.id == this.$route.params.id ))
        // if( !userOrders.orders.some( order => order.id == this.$route.params.id ) ) { window.location.replace('/distribution/myorders') }
        // this.order_data = userOrders.orders.filter( order => order.id == this.$route.params.id )[0]
        // console.log(this.order_data)
    },
}
</script>

<style scoped>
.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 300px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: -50%;
  left: 110%;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: 0;
  border-width: 5px;
  border-style: solid;
  border-color: transparent black transparent transparent;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>>